import { render, staticRenderFns } from "./FormTabela.vue?vue&type=template&id=5c9300c1"
import script from "./FormTabela.vue?vue&type=script&lang=js"
export * from "./FormTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports